module.exports = __webpack_public_path__ + "img/10-2.82215d72.png";